module.exports = __webpack_public_path__ + "media/bootstrap-icons/cup-8c39555f.svg";